import styled, { css } from 'styled-components';
import type { RouterLinkProps } from '@redux-first-router-link';
import { RouterLink } from '@redux-first-router-link';
import { Button } from '@simplywallst/ui-core';
import { hexToRgbA } from '@/utilities/colors';

export const AccountNavigation = styled('nav')`
  position: absolute;
  bottom: 1px;
  right: ${({ theme }) => theme.x2spacePx}px;
  width: 200px;
`;

export const Notification = styled.div`
  border-bottom: 1px solid ${({ theme }) => hexToRgbA(theme.color.white, 0.1)};
  padding: ${({ theme }) => (theme.x1space + 0.4) * 10}px
    ${({ theme }) => theme.x2spacePx}px;
  > p {
    ${({ theme }) => theme.typography.xSmall}
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const NavWrapper = styled.div`
  position: absolute;
  top: -6px;
  left: 0;
  width: 100%;
  background: ${({ theme }) => theme.color.spaceGray};
  border-radius: 4px;
`;

export const NavList = styled.ul<{ hasLimit: boolean }>`
  > li {
    ${({ theme }) => theme.typography.xSmall}
    ${({ hasLimit }) =>
      hasLimit === false &&
      css`
        &:first-child {
          > * {
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
          }
        }
      `}
    &:last-child {
      border-top: 1px solid ${({ theme }) => hexToRgbA(theme.color.white, 0.1)};
      > * {
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
  }
`;

export const NavItem = styled(RouterLink)<RouterLinkProps>`
  display: block;
  padding: ${({ theme }) => (theme.x1space + 0.4) * 10}px
    ${({ theme }) => theme.x2spacePx}px;
  &:hover {
    background-color: ${({ theme }) => theme.color.brand01};
  }
`;

interface NavItemHREFProps {
  rel: string;
}

export const NavItemHREF = styled(Button)<NavItemHREFProps>`
  border-radius: 0px;
  display: block;
  box-shadow: none;
  padding: ${({ theme }) => (theme.x1space + 0.4) * 10}px
    ${({ theme }) => theme.x2spacePx}px;
  &:hover {
    background-color: ${({ theme }) => theme.color.brand01};
    box-shadow: none;
  }
`;
export const ViewCompaniesLink = styled('a')`
  cursor: pointer;
`;
